import Rest from '../Rest'

export default class ModalityService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/modalities'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
